import React, { useState, createRef, useEffect } from "react";
import axios from "axios";
import { useLocation } from 'react-router-dom';
import ReactLoading from 'react-loading';
import config from "../config"
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import queryString from 'query-string';
import Shipment_steps from './Shipment_steps'

const Package_list = () => {
    let navigate = useNavigate();
  const[loadingstate,setLoadingstate] = React.useState({loading:false})
  const[errorstate,seterrorstate] = React.useState({message:""})
  const[dimensionState,setdimensionState] = React.useState({companyDetail:[]})
  const location = useLocation();

  let userDetail = localStorage.getItem('ship_rocket_user');
  console.log("userDetail====", config.UserId);
  let userData = {};
  if (userDetail != null) {
    userData = JSON.parse(userDetail)
  }
  
  //  console.log("location==>",location)
  let  parsed = queryString.parse(location.search);
console.log("parsed",parsed);

let dimensions = []
if(Array.isArray(parsed.dimensions)){
   dimensions = parsed.dimensions
   dimensions = dimensions.map((sub)=>{
    
    console.log("dimensions------>",
    Object.assign({},sub.split(',') ))
    return  Object.assign({},sub.split(',') )
    
   })
  //  console.log("arr",arr)
}else{
  dimensions.push(parsed.dimensions)
  dimensions = dimensions.map((sub)=>{
    
    console.log("dimensions------>",
    Object.assign({},sub.split(',') ))
    return  Object.assign({},sub.split(',') )
    
   })
}
console.log("dimensions",dimensions)
let total_weight = 0
dimensions.map((sub)=>{
  total_weight = Number(total_weight)+ Number(sub[3])
})
console.log("total_weight",total_weight)

let shipment = []
if(Array.isArray(parsed.items)){
  shipment = parsed.items
  shipment = shipment.map((sub)=>{
    
    console.log("shipment------>111",
    Object.assign({},sub.split(',') ))
    return  Object.assign({},sub.split(',') )
    
   })
  //  console.log("arr",arr)
}else{
  shipment.push(parsed.items)
  shipment = shipment.map((sub)=>{
    
    console.log("shipment------>22",
    Object.assign({},sub.split(',') ))
    return  Object.assign({},sub.split(',') )
    
   })
}
console.log("shipment ======= ?",shipment)
let total_value = 0
shipment.map((sub)=>{
  total_value = Number(total_value)+ Number(sub[0])
})
console.log("total_weight",total_weight)

  const [state, setState] = useState([]);
  let apiFlag = true;

  useEffect(() => {
    if(apiFlag){
      apiFlag = false;
    get_list()  
    dimension_detail()    
    }
}, [])

const dimension_detail = () =>{
  let full_api = config.apiUrl + `/user/get_company_info_api`;
  let sendData = {};

  axios.post(full_api, sendData, { headers: config.headers }).then(res => {
    setdimensionState({...dimensionState,companyDetail:res.data.companyDetail});
    console.log("rnmmmmm", res);
  }).catch((e) => {
    // toast.configure()
     //toast.error("Some thing went wrong")
    console.log("----error:   ", e);
  })
}

  const get_list = async (sortValue) => {
    setLoadingstate({...loadingstate,loading:true})
    
    let sort = "default";
    if(sortValue) {
      sort = sortValue
    }
    let dataToSend = {customer_id:userData.customer_id,from_postal_code:parsed.sender_postal_code , from_country_code:parsed.sender_country_code , from_city_id:parsed.sender_city_id, to_postal_code:parsed.receiver_postal_code,to_country_code:parsed.receiver_country_code , weight:"",length:"",height:"",width:"",sort_by:sort , parcel_type:parsed.shipment_type , mode:parsed.mode
  };
  dataToSend.weight = dimensions.map((sub)=>(
    sub[3]
  ))
  dataToSend.length = dimensions.map((sub)=>(
    sub[2]
  ))
  dataToSend.height = dimensions.map((sub)=>(
    sub[0]
  ))
  dataToSend.width = dimensions.map((sub)=>(
    sub[1]
  ))
    console.log("datatoSend",dataToSend)
    let url = config.apiUrl + '/shipment/shipment_rate_time';
   
   // console.log("headers => ", config.headers);
   
    
    axios.post(url, dataToSend, { headers: config.headers })
        .then((responseJson) => {
          console.log("responseJson => ", responseJson.data);
          setLoadingstate({...loadingstate,loading:false})
          if(responseJson.data.status=="success"){
            setState(responseJson.data.output)
            if(responseJson.data.output.length==0){
              seterrorstate({...errorstate,message:"No services available for the selected route and package combination."})
            }
          }

          else{
          
          //  seterrorstate({...errorstate,message:"No services available for the selected route and package combination."})
          //  console.log("message",responseJson.data.message);
           Swal.fire({
            icon: 'error',
            // title: 'Oops...',
            text: 'Something Went wrong',
            
          })
          }
           
        })
        .catch((error) => {
            //Hide Loader
            setLoadingstate({...loadingstate,loading:false})
            console.log(error);
        });
};

const sort_by = (e) =>{
console.log(e.target.value);
get_list(e.target.value)
}
  return (
    <div>
      <section class="p-5">
  <div class="container">
  <Shipment_steps value={3}/>
    <div class="row p-5">
      <div class="col-12 col-md">
        <section class="mb-3">
            <div class="row">
              <div class="col-12 col-md-4 text-end">
                <a href="./" class="btn btn-outline-main">
                    <div class="d-flex justify-content-between">
                        <div class="">Edit your shipping preferences</div>
                        <div class="ps-2 "><i class="material-icons-outlined">sort</i></div>
                    </div>
                </a>
              </div>
              <div class="col-12 col-md"></div>
              <div class="col-12 col-md-3">
                <div class="form-floating">
                    <select class="form-select" id="sel1" name="sellist" onChange={(e)=>sort_by(e)}>
                    <option value="default">Default</option>
                        <option value="low">low-to-high</option>
                        <option value="high">high-to-low</option> 
                    </select>
                    <label for="sel1" class="form-label">Sort by...</label>
                </div>
              </div>
              
            </div>
        </section>
        <section class="package_list_box_simple">
        {loadingstate.loading?
          <div style={{width:"100%", display: "flex",
  justifyContent: "center"}}>

    
        <ReactLoading type={"bars"} color={"#f24827"} height={300} width={89} />
        </div>
        :""}
         <h3>
            {errorstate.message}</h3>
            {(state.length != 0) ?
          state.map((item,index)=>
            <div class="card border-0 shadow-sm ">
              <div class="card-body">
                <div class="row">
                    
                    <div class="col-12 col-md text-center mt-3">
                   <img src={`https://cdn.mojoship.in/images/${item.carrierImage}`}className="img-fluid" />
                    </div>
                    
                    <div class="col-12 col-md mt-3">
                      <h2>{item.service_name}</h2>
                      <p>{item.service_provider}</p>
                    </div>
                    <div class="col-12 col-md  mt-3 text-end">
                        <h1>{dimensionState.companyDetail.map((subscriber)=>( 
                                  <>{subscriber.set_currency}</>
                                 ))}{parseFloat(Number(item.total_charges)+Number(item.commission_charge)).toFixed(2)}</h1>
                        <small class="text-muted">+VAT</small>
                        <div class="d-grid">
                        <a  onClick={()=>navigate({
                        pathname:`/payment_details`,
                        search:`sender_name=${parsed.sender_name}&sender_address=${parsed.sender_address}&sender_country=${parsed.sender_country}&sender_country_code=${parsed.sender_country_code}&sender_postal_code=${parsed.sender_postal_code}&sender_state_name=${parsed.sender_state_name}&sender_city=${parsed.sender_city}&sender_address_id=${parsed.sender_address_id}&sender_city_id=${parsed.sender_city_id}&sender_mobile=${parsed.sender_mobile}&sender_email=${parsed.sender_email}&receiver_name=${parsed.receiver_name}&receiver_email=${parsed.receiver_email}&receiver_mobile=${parsed.receiver_mobile}&receiver_address=${parsed.receiver_address}&receiver_country=${parsed.receiver_country}&receiver_country_code=${parsed.receiver_country_code}&receiver_postal_code=${parsed.receiver_postal_code}&receiver_city=${parsed.receiver_city}&receiver_state_name=${parsed.receiver_state_name}&return_name=${parsed.return_name}&return_email=${parsed.return_email}&return_mobile=${parsed.return_mobile}&return_address=${parsed.return_address}&return_country=${parsed.return_country}&return_country_code=${parsed.return_country_code}&return_postal_code=${parsed.return_postal_code}&return_city=${parsed.return_city}&return_state_name=${parsed.return_state_name}&mode=${parsed.mode}&company_name=${item.service_name}&total_amount=${parseFloat(Number(item.total_charges)+Number(item.commission_charge)).toFixed(2)}&packaging_type=${item.packagingType!=undefined && item.packagingType!=""? item.packagingType:""}&carrier_id=${item.carrier_id}&courier_id=${item.courier_id!=undefined && item.courier_id!=""?item.courier_id:""}&serviceType=${item.serviceType!=undefined && item.serviceType!=""? item.serviceType:""}&service_provider=${item.service_provider}&product_type_name=${item.product_type_name!=undefined && item.product_type_name!=""?item.product_type_name:""}&shipment_type=${parsed.shipment_type}&service_provider_id=${item.service_provider_id!=undefined && item.service_provider_id!=""? item.service_provider_id:""}&order_id=${parsed.order_id}&order_date=${parsed.order_date}&insurance=${parsed.insurance}&cod_amount=${parsed.cod_amount}&payment_mode=${parsed.payment_mode}${dimensions.map((sub)=>(
                          `&dimensions=${sub[0]},${sub[1]},${sub[2]},${sub[3]}`))}${shipment.map((sub)=>(`&items=${sub[0]},${sub[1]},${sub[2]}`
                          ))}`})} class="btn btn-main btn-block">Book Now</a>
                        </div>
                    </div>
                </div>
              </div>
            </div>
            ):""}
        </section>
      </div>
      {/* <div class="col-12 col-md-4">
        <div class="card bg-light border-0 shadow-sm">
          <div class="card-body">
            <h5 class="mb-3">Summary</h5>
            <strong>FROM</strong>
            <p>{parsed.origin_postal_code} - {parsed.origin_city} , {parsed.origin_country_name}</p>
            <strong>TO</strong>
            <p>{parsed.destination_postal_code} - {parsed.destination_city} , {parsed.destination_country_name}</p>

            <hr/>
            {dimensions.map((sub,index)=>(
              <>
            <strong>PARCEL ({index+1})</strong>
             <p className="text-muted">{sub[0]} ({dimensionState.companyDetail.map((subscriber)=>( 
                                  <>{subscriber.set_weight}</>
                                 ))}) {sub[1]} x {sub[3]} x {sub[2]} ({dimensionState.companyDetail.map((subscriber)=>( 
                                  <>{subscriber.set_dimension}</>
                                 ))})</p>
            </>))}
          </div>
        </div>
      </div> */}
      <div class="col-md-4 bg-light mb_display_none">
        <section class="ps-4 pt-3">
          <h3 class="fs-5 pb-3">Basic information</h3>
          <div class="row">
          <div class="col-md-6">
              <small class="text-muted">Pickup</small>
              <h4 class="fs-6">{parsed.sender_address}, {parsed.sender_state_name}, {parsed.sender_city} - {parsed.sender_postal_code} </h4>
              <p>{parsed.sender_country}</p>
            </div>
            <div class="col-md-6">
              <small class="text-muted">Delivery</small>
              <h4 class="fs-6">{parsed.receiver_address}, {parsed.receiver_state_name}, {parsed.receiver_city} - {parsed.receiver_postal_code}</h4>
              <p>{parsed.receiver_country}</p>
            </div>
            <div class="col-md-12">
              <small class="text-muted">Item(s)</small>
              <h4 class="fs-5">{shipment.length}</h4>
            </div>
          </div>
        </section>

        <hr class="m-4" />

        <section class="ps-4">
          <h3 class="fs-5 pb-3">Shipping Items</h3>
          {dimensions.map((sub,index)=>(
              <>
            <strong>PARCEL ({index+1})</strong>
             <p className="text-muted">{sub[3]} ({dimensionState.companyDetail.map((subscriber)=>( 
                                  <>{subscriber.set_weight}</>
                                 ))}) {sub[0]} x {sub[1]} x {sub[2]} ({dimensionState.companyDetail.map((subscriber)=>( 
                                  <>{subscriber.set_dimension}</>
                                 ))})</p>
            </>))}
        </section>

        <hr class="m-4" />


        <section class="ps-4">
          <h3 class="fs-5 pb-3">Order details</h3>
          <div class="row">
            <div class="col-md-6">
              <small class="text-muted">Mode</small>
              <h4 class="fs-5">{parsed.mode}</h4>
            </div>
            <div class="col-md-6">
              <small class="text-muted">Type</small>
              <h4 class="fs-5">{parsed.shipment_type}</h4>
            </div>
            <div class="col-md-6">
              <small class="text-muted">Total Weight</small>
              <h4 class="fs-5">{total_weight} ({dimensionState.companyDetail.map((subscriber)=>( 
                                  <>{subscriber.set_weight}</>
                                 ))})</h4>
            </div>
          </div>
        </section>
        <hr class="m-4" />

        <section class="ps-4">
          <h3 class="fs-5 pb-3">Pricing details</h3>
          {shipment.map((sub , index)=>(
          <div class="row">
           
            <div class="col-md-6">
              <small class="text-muted">Item {index+1}</small>
            </div>
           
            <div class="col-md-6">
              <h4 class="fs-6">{dimensionState.companyDetail.map((subscriber)=>( 
                                  <>{subscriber.set_currency}</>
                                 ))} {sub[0]}</h4>
            </div>
          </div>
           ))}
        </section>
        <section class="ps-4">
          <div class="row pt-4">
            <div class="col-md-6">
              <h4 class="fs-4">Total Item(s) Value</h4>
            </div>
            <div class="col-md-6">
              <h4 class="fs-4">{dimensionState.companyDetail.map((subscriber)=>( 
                                  <>{subscriber.set_currency}</>
                                 ))} {total_value}</h4>
            </div>
          </div>
        </section>

      </div>
    </div>      
  </div>
</section>
    </div>
  )
}

export default Package_list
